import { CardContent, Stack } from "@mui/material";
import {
  CardWithIntent,
  CbhIcon,
  type IconType,
  Illustration,
  type IllustrationType,
  LoadingSpinner,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import { type IntentVariant } from "@src/appV2/redesign/system/ui-theme";

interface BaseReferralStatusCardProps {
  intent?: IntentVariant;
  illustration?: IllustrationType;
  icon?: IconType;
  title: string;
  description?: string;
  isLoading?: boolean;
}

export function BaseReferralStatusCard(props: BaseReferralStatusCardProps) {
  const { intent = "neutral", illustration, icon, title, description, isLoading } = props;

  return (
    <CardWithIntent intent={intent}>
      <CardContent>
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={5}
          sx={{
            textAlign: "center",
          }}
        >
          {illustration && <Illustration type={illustration} />}
          {icon && <CbhIcon type={icon} size="xLarge" />}
          {isLoading && <LoadingSpinner size="small" />}
          <Text semibold variant="h5" color={(theme) => theme.palette.text.primary}>
            {title}
          </Text>
          {description && (
            <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
              {description}
            </Text>
          )}
        </Stack>
      </CardContent>
    </CardWithIntent>
  );
}
